<app-dc-pane 
  class="documents" 
  [lightBackground]="true" 
  [headerLinkRight]="'View all documents'"
  (headerLinkEmitter)="openDocuments()" 
  [noScroll]="false">
  <ng-container class="heading">
    {{documents?.length || ''}} Documents
  </ng-container>

  <div *ngIf="documents.length" class="docsContainer">
    <div *ngFor="let doc of lastVersions; index as i">
      <div class="documentCard">
        <div>
          <img src="assets/{{getFileType(doc.fileUrl)}}.svg" class="docSVG" alt="document svg" />
        </div>
        <div class="docLabelAndNameDiv" (click)="downloadFile(doc.id)" title="Download document">
          <div class="docLabel">{{ doc.createdAt | date: 'dd/MM/YYYY HH:mm:ss' }}</div>
          <div class="docPara">{{ getTypeName(doc.type) }} - {{ doc.language }}</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!documents.length" class="noDocsContainer">
    <div>
      <img src="assets/doument-magnifying-glass.svg" class="docSearchIcon" />
      <p class="noDocsText">No Documents Available</p>
    </div>
  </div>
</app-dc-pane>